import ExcluirTypes from './types';

export const removerContratoDoProtocolo = (contrato, onSuccess, onError) => ({
    type: ExcluirTypes.REMOVER_CONTRATO_DO_PROTOCOLO,
    payload: { contrato, onSuccess, onError },
});

export const searchRequest = (filtros) => ({
    type: ExcluirTypes.SEARCH_REQUEST,
    payload: filtros,
});

export const searchFailure = (error) => ({
    type: ExcluirTypes.SEARCH_FAILURE,
    payload: error,
});

export const searchSuccess = (protocolos) => ({
    type: ExcluirTypes.SEARCH_SUCCESS,
    payload: protocolos,
});

export const selectMultiples = (payload) => ({
    type: ExcluirTypes.SELECT_MULTI,
    payload,
});

export const searchReasonRequest = () => ({
    type: ExcluirTypes.SEARCH_REASON_REQUEST,
});

export const searchReasonFailure = (error) => ({
    type: ExcluirTypes.SEARCH_REASON_FAILURE,
    payload: error,
});

export const searchReasonSuccess = (reason) => ({
    type: ExcluirTypes.SEARCH_REASON_SUCCESS,
    payload: reason,
});

export const select = (id) => ({
    type: ExcluirTypes.SELECT,
    payload: { id },
});

export const deleteRequest = (payload) => ({
    type: ExcluirTypes.DELETE_REQUEST,
    body: payload,
});

export const deleteFailure = (error) => ({
    type: ExcluirTypes.DELETE_FAILURE,
    payload: error,
});

export const deleteProtocolRequest = () => ({
    type: ExcluirTypes.DELETE_REQUEST,
});

export const deleteProtocolFailure = (error) => ({
    type: ExcluirTypes.DELETE_FAILURE,
    payload: error,
});

export const removeContrato = (mensagem) => ({
    type: ExcluirTypes.CONFIRMAR_EXCLUSAO_CONTRATO,
    payload: { mensagem },
});

export const removeProtocolo = (id) => ({
    type: ExcluirTypes.CONFIRMAR_EXCLUSAO_PROTOCOLO,
    payload: { id },
});

export const clearStatus = () => ({
    type: ExcluirTypes.CLEAR_STATUS,
});
